import React from "react";
import { InView } from "react-intersection-observer";
import "../styles/MicrosoftSynectiksSection.css";
import BusinessWomanImage from "../../assets/business-animatedWomen-m365.png";
import M365Logo from "../../assets/m365-logo.svg";

const MicrosoftSynectiksSection = () => {
  return (
    <section className="microsoft-synectiks-section section-spacing">
      <div className="microsoft-synectiks-container">
        {/* Left Content */}
        <InView triggerOnce={true} threshold={0.1} initialInView={true}>
          {({ inView, ref }) => (
            <article
              ref={ref}
              className={`microsoft-synectiks-content ${
                inView ? "animate" : ""
              }`}
            >
              <header>
                <h1>
                  Reimagine What's Possible when Microsoft 365 Meets{" "}
                  <span className="company-name">
                    SYNECT<span className="company-name-red-i">I</span>KS
                  </span>
                  .
                </h1>
              </header>
              <p>
                We go beyond migrations. At{" "}
                <span className="company-name">
                  SYNECT<span className="company-name-red-i">I</span>KS
                </span>
                , we help you build a secure, agile, and AI-powered workplace
                with Microsoft 365 and Copilot. Our end-to-end transformation
                and managed services ensure a cost-effective, always up-to-date
                digital environment designed for the future of work.
              </p>
            </article>
          )}
        </InView>
        {/* Right Image */}
        <InView triggerOnce={true} threshold={0.1} initialInView={true}>
          {({ inView, ref }) => (
            <aside
              ref={ref}
              className={`microsoft-synectiks-image ${inView ? "animate" : ""}`}
            >
              <div className="microsoft-synectiks-image-row">
                <figure className="m365-logo-container">
                  <img
                    src={M365Logo}
                    alt="Microsoft 365 Logo"
                    className="m365-logo"
                  />
                </figure>
                <figure>
                  <img
                    src={BusinessWomanImage}
                    alt="Business woman working with Microsoft 365 solutions"
                    className="business-woman-image"
                  />
                </figure>
              </div>
            </aside>
          )}
        </InView>
      </div>
    </section>
  );
};

export default MicrosoftSynectiksSection;
